import { useEffect, useState } from 'react';
import { ChartDrawer, RealPricePath, setup, env } from '@zero/price-path';
import { getValueByEnv } from '@/env';

setup({
  isShop: false,
  env: getValueByEnv({ envDev: env.TEST, envProd: env.PRO, envRelease: env.PRE, envBeta: env.TEST }),
});

function EjectOnclickEv(props) {
  useEffect(() => {
    props.onClick?.();
    // eslint-disable-next-line
  }, []);

  return null;
}

let OrderOfChartDrawer = function OrderOfChartDrawer(props, ref) {
  const [_, refresh] = useState(0);
  const [propsToChartBrawer, setPropsToChartBrawer] = useState(null);

  useEffect(() => {
    window.ACORE = window.ACORE || {};
    window.ACORE.orderedPricePath = {
      RealPricePath: {
        show(params) {
          if (!params) return;
          setPropsToChartBrawer({...params, componentType: 'RealPricePath'});
          refresh((a) => a + 1);
        },
      },
      ChartDrawer: {
        show(params) {
          if (!params) return;
          setPropsToChartBrawer({...params, componentType: 'ChartDrawer'});
          refresh((a) => a + 1);
        },
      }
    };
  }, []);

  if (!propsToChartBrawer) return null;

  if (propsToChartBrawer.componentType === 'RealPricePath') {
    return (
      <RealPricePath {...propsToChartBrawer} key={_}>
        <EjectOnclickEv />
      </RealPricePath>
    );
  } else {
    return (
      <ChartDrawer {...propsToChartBrawer} key={_}>
        <EjectOnclickEv />
      </ChartDrawer>
    );
  }
};

export default OrderOfChartDrawer;
